import React from 'react'

export default function IconOneCol({ colour = 'currentColor', ...rest }) {
    return (
        <svg
            preserveAspectRatio='none'
            width='248'
            height='24'
            viewBox='0 0 248 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
        >
            <path
                d='M4 0.5H244C245.933 0.5 247.5 2.067 247.5 4V20C247.5 21.933 245.933 23.5 244 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z'
                fill='#EEEEED'
            />
            <path
                d='M4 0.5H244C245.933 0.5 247.5 2.067 247.5 4V20C247.5 21.933 245.933 23.5 244 23.5H4C2.067 23.5 0.5 21.933 0.5 20V4C0.5 2.067 2.067 0.5 4 0.5Z'
                stroke='#E1E1E0'
            />
        </svg>
    )
}
